import React, { Component } from "react";
import GoogleMapReact from "google-map-react";
import ReactDOM from "react-dom/client";
import CircleMarker from "../lib/map/circlemarker.jsx";
import Circles from "../lib/map/circles.jsx";
import Loader from "../lib/map/loader.jsx";

class MapInsights extends Component {
  constructor(props) {
    super(props);
    this.initMap = this.initMap.bind(this);
    this.state = {
      loader: true,
      markers: false,
      zoom: 9,
      center: {
        lat: parseFloat(this.props.lat),
        lng: parseFloat(this.props.lng),
      },
    };
  }

  initMap(map, googlemaps) {
    var self = this;

    for (var i = 0; i < 4; i++) {
      Circles[i]["instance"] = new googlemaps.Circle({
        strokeColor: Circles[i].strokeColor,
        strokeOpacity: 1,
        strokeWeight: Circles[i].strokeWeight,
        fillColor: Circles[i].fillColor,
        fillOpacity: 0.1,
        map,
        center: this.state.center,
        radius: Circles[i].radius,
      });
    }
    self.setState({ markers: true, loader: false });
  }

  componentDidMount() {
    this.setState({ loader: false });
    this.timeout = null;
  }

  render() {
    return (
      // Important! Always set the container height explicitly
      <div style={{ height: "450px", width: "100%" }}>
        <GoogleMapReact
          ref="map"
          bootstrapURLKeys={{
            key: google_maps_key,
            language: lang,
            region: region.toLowerCase(),
          }}
          zoom={this.state.zoom}
          center={this.state.center}
          options={{
            minZoom: 9,
            maxZoom: 9,
            streetViewControl: false,
            disableDefaultUI: true,
            draggable: false,
          }}
          onGoogleApiLoaded={({ map, maps }) => this.initMap(map, maps)}
          yesIWantToUseGoogleMapApiInternals={true}
        >
          {this.state.loader ? <Loader /> : ""}
          {this.state.markers ? (
            <CircleMarker lat={this.state.lat} lng={this.state.lng} index="0" />
          ) : (
            ""
          )}
          {this.state.markers ? (
            <CircleMarker lat={this.state.lat} lng={this.state.lng} index="1" />
          ) : (
            ""
          )}
          {this.state.markers ? (
            <CircleMarker lat={this.state.lat} lng={this.state.lng} index="2" />
          ) : (
            ""
          )}
          {this.state.markers ? (
            <CircleMarker lat={this.state.lat} lng={this.state.lng} index="3" />
          ) : (
            ""
          )}
        </GoogleMapReact>
      </div>
    );
  }
}
let mapInsights = document.getElementById("mapInsights");

if (mapInsights !== null) {
  let initInsightsMap = function () {
    const mapInsightsRoot = ReactDOM.createRoot(mapInsights);
    mapInsightsRoot.render(
      <MapInsights
        lat={mapInsights.dataset.lat}
        lng={mapInsights.dataset.lng}
      />
    );
  };

  initInsightsMap();
}
